import React, {useContext, useState} from 'react';
import {Context} from "../store/reducer";

/**
 * 道路台帳附図の利用規約モーダル。
 * このモーダルが開いている間は地図に地物を描画しない。
 * @returns {false|JSX.Element}
 * @constructor
 */
const Component = () => {

    const { state, dispatch } = useContext(Context);
    let [isOpened, setIsOpened] = useState(true);

    /**
     * 同意した場合はフラグをtrueにする。
     */
    const agree = () => {

        dispatch({
            type    : 'SET_MODAL_AGREE',
            category: "vis_92"
        })

        setIsOpened(false)
    }

    const disAgree = () => {
        setIsOpened(false)
    }

    return (isOpened && <>
        <div class="modal-first">
            <div class="modal-first-inner">

                <section class="u-pb-xs">
                    <p class="u-fs-12 u-lh-sm">本サイトにおける台帳附図は参考図です。注意事項をお読み頂き、ご自身の責任と判断でご利用下さい。</p>
                </section>

                <section class="u-pb-xxs">
                    <h5>【道路台帳附図について】</h5>
                    <ul class="u-fs-12 u-lh-sm">
                        <li class="u-pb-xs">・本サイトは、道路法に基づいて広島県が道路管理者として管理する道路の道路台帳附図を掲載したものです。</li>
                        <li class="u-pb-xs">・国が管理する国道については、管轄の国道事務所に、広島市内の国道（国が管理する区間を除く）・県道については広島市の各区役所に、市町道については各市町の道路担当部署にお問い合わせください。</li>
                    </ul>
                </section>
                <section class="u-pb-xxs">
                    <h5>【注意事項】</h5>
                    <p class="u-fs-12 u-lh-sm u-pb-xs">本サイトで公開している台帳附図は現状を正確に投影したものではありません。</p>
                    <ul class="u-fs-12 u-lh-sm">
                        <li class="u-pb-xs">・道路の改良などにより現在の道路状況と違う場合があります。</li>
                        <li class="u-pb-xs">・未掲載の道路台帳附図があるため、路線延⾧が網羅されていない箇所があります。</li>
                        <li class="u-pb-xs">・背景図と道路台帳附図の表示している場所が一致していない場合があります。</li>
                        <li class="u-pb-xs">・背景図の示す路線の向きと道路台帳附図の示す路線の向きは一致していません。道路台帳附図に記載してある方位記号を参考にしてください。</li>
                        <li class="u-pb-xs">・道路台帳附図に記載されている幅員は参考数値です。現況とは誤差があります。</li>
                        <li class="u-pb-xs">・表示されるディスプレイによって縮尺が変わるため、道路台帳附図に記載されている縮尺は参考となります。</li>
                        <li class="u-pb-xs">・道路台帳附図に表記されている幅員や道路表示は、土地の境界を示すものではありません。</li>
                        <li class="u-pb-xs">・地形や建物などの表記は現在の状況と異なる場合があります。</li>
                        <li class="u-pb-xs">・本サイトの利用による直接的又は間接的損害、損失等について、広島県は一切の責任を負いません。</li>
                    </ul>
                </section>
                <section class="u-pb-xs">
                    <h5>【道路に関するご相談】</h5>
                    <p class="u-fs-12 u-lh-sm">広島県が管理する道路の占用や改築、幅員証明の発行、道路台帳附図の記載内容などについては下記＜問い合わせ先＞の各建設事務所（支所）にご相談下さい。</p>
                </section>
                <section class="u-pb-xxs">
                    <h5>【問い合わせ先】</h5>
                    <div class="c-tbl-sp2">
                        <table class="c-tbl c-tbl-1">
                            <tbody>
                            <tr>
                                <th>名称</th>
                                <th>所管市町</th>
                                <th>連絡先</th>
                            </tr>
                            <tr>
                                <td>西部建設事務所<br />管理第一課、管理第二課</td>
                                <td>江田島市、府中町、海田町、熊野町、坂町</td>
                                <td>082-250-8150</td>
                            </tr>
                            <tr>
                                <td>西部建設事務所呉支所<br />管理課</td>
                                <td>呉市</td>
                                <td>0823-22-5400（代表）</td>
                            </tr>
                            <tr>
                                <td>西部建設事務所廿日市支所<br />管理用地課</td>
                                <td>大竹市、廿日市市</td>
                                <td>0829-32-1141（代表）</td>
                            </tr>
                            <tr>
                                <td>西部建設事務所安芸太田支所<br />管理用地課</td>
                                <td>安芸太田町、北広島町</td>
                                <td>0826-22-0545</td>
                            </tr>
                            <tr>
                                <td>西部建設事務所 東広島支所<br />管理用地課</td>
                                <td>竹原市、東広島市、大崎上島町</td>
                                <td>082-422-6911（代表）</td>
                            </tr>
                            <tr>
                                <td>東部建設事務所<br />管理課</td>
                                <td>福山市、府中市、神石高原町</td>
                                <td>084-921-1311（代表）</td>
                            </tr>
                            <tr>
                                <td>東部建設事務所三原支所<br />管理課</td>
                                <td>三原市、尾道市、世羅町</td>
                                <td>0848-64-4263</td>
                            </tr>
                            <tr>
                                <td>北部建設事務所<br />管理課</td>
                                <td>三次市、安芸高田市</td>
                                <td>0824-63-5181（代表）</td>
                            </tr>
                            <tr>
                                <td>北部建設事務所庄原支所<br />管理用地課</td>
                                <td>庄原市</td>
                                <td>0824-72-2015（代表）</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </section>


                <p className="u-txt-c" onClick={agree} style={{fontSize:"0.7em", cursor: 'pointer' }}><span style={{"text-decoration": "underline"}}>閉じる</span></p>
            </div>
        </div>
    </>);
}

export default Component
